import { UserFormValues } from 'types/state';
import { useUserEditorStateOrFallback } from 'hooks/userEditor/useUserEditorState';

export const useUserEditorFormValues = (id: number): UserFormValues => {
  const { formValues } = useUserEditorStateOrFallback(id);

  return formValues;
};
